import { Button, Empty, Flex, Modal, Spin } from 'antd';
import axios from 'axios';
import type { Dayjs } from 'dayjs';
import React, { useEffect, useState } from 'react';
import ArrowRightIcon from '../../../icons/arrow-right-icon.svg';
import { NavButton } from './nav-button';
import { localize } from '/react4xp/mixins/helpers';

type Props = {
    selectedDay: Dayjs;
    selectDay: (day: Dayjs) => void;
    translations: Record<string, string>;
};

export function CalendarEvents({ selectedDay, selectDay, translations }: Props) {
    const [events, setEvents] = useState([]);
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        setIsLoading(true);
        setEvents([]);
        axios
            .get('/services/isnaportal/open-api/get-all-message-events-by-date', {
                params: {
                    taxCalendarDate: selectedDay.format('2024-08-DD'),
                },
            })
            .then((res) => {
                setEvents(Array.isArray(res.data) ? res.data : []);
            })
            .finally(() => {
                setIsLoading(false);
            });
    }, [selectedDay]);

    const selectPrevDay = () => {
        selectDay(selectedDay.subtract(1, 'day'));
    };
    const selectNextDay = () => {
        selectDay(selectedDay.add(1, 'day'));
    };

    console.log('selectedDay', selectedDay);

    return (
        <div className="events">
            <Flex
                gap={10}
                className="title"
            >
                <NavButton
                    variant="white"
                    direction="left"
                    onClick={selectPrevDay}
                />
                <NavButton
                    variant="white"
                    direction="right"
                    onClick={selectNextDay}
                />
                <p className="title__date">{selectedDay?.format('DD MMMM')}</p>
            </Flex>

            <Spin spinning={isLoading}>
                {events?.length !== 0 && (
                    <ul className="events__list">
                        {events?.map((event) => (
                            <EventListItem
                                key={event.id}
                                event={event}
                                translations={translations}
                            />
                        ))}
                    </ul>
                )}
            </Spin>

            {!isLoading && events?.length === 0 && (
                <Flex
                    justify="center"
                    align="center"
                    style={{
                        paddingTop: 40,
                    }}
                >
                    <Empty />
                </Flex>
            )}
        </div>
    );
}
const EventListItem = ({ event, translations }) => {
    const [isModalOpen, setIsModalOpen] = useState(false);
    const openModal = () => setIsModalOpen(true);
    const closeModal = () => setIsModalOpen(false);

    return (
        <li
            className="events__list__item"
            key={event.id}
        >
            <p className="title">{event.title.nameRu}</p>

            <div
                style={{
                    height: 110,
                    overflow: 'hidden',
                }}
                dangerouslySetInnerHTML={{
                    __html: event.contentEmail.nameRu,
                }}
            />

            <div className="footer">
                <button
                    className="footer__more-button"
                    onClick={openModal}
                >
                    <p>{localize('more-detailed', translations)}</p>
                    <ArrowRightIcon />
                </button>
            </div>

            <Modal
                title={
                    <div
                        className="div__text"
                        dangerouslySetInnerHTML={{
                            __html: event.title.nameRu,
                        }}
                    />
                }
                open={isModalOpen}
                onCancel={closeModal}
                style={{ minWidth: '800px' }}
                footer={
                    <Flex
                        justify="end"
                        align="center"
                        gap={100}
                    >
                        <div className="">
                            <div
                                dangerouslySetInnerHTML={{
                                    __html: event.taxCalendarDate,
                                }}
                            />
                        </div>
                        <Button
                            className=""
                            color="gold"
                            onClick={closeModal}
                            style={{
                                alignItems: 'center',
                            }}
                        >
                            {localize('button.close', translations)}
                        </Button>
                    </Flex>
                }
            >
                <div
                    className=""
                    dangerouslySetInnerHTML={{
                        __html: event.content.nameRu,
                    }}
                />
            </Modal>
        </li>
    );
};
